import React from 'react';
import './UXStates.css';

export const LoadingSpinner = ({ message = 'Loading...', size = 'medium' }) => (
  <div className={`ux-loading ${size}`}>
    <div className="ux-spinner"></div>
    {message && <p className="ux-loading-message">{message}</p>}
  </div>
);

export const EmptyState = ({ 
  title = 'Nothing here', 
  description, 
  actionLabel, 
  onAction,
  icon = '📭'
}) => (
  <div className="ux-empty-state">
    <div className="ux-empty-icon">{icon}</div>
    <h3 className="ux-empty-title">{title}</h3>
    {description && <p className="ux-empty-description">{description}</p>}
    {actionLabel && onAction && (
      <button className="ux-empty-action btn-primary" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export const SuccessState = ({ message, onDismiss }) => (
  <div className="ux-success-state">
    <div className="ux-success-icon">✓</div>
    <p className="ux-success-message">{message}</p>
    {onDismiss && (
      <button className="ux-success-dismiss" onClick={onDismiss}>×</button>
    )}
  </div>
);

export const ErrorState = ({ 
  message, 
  onRetry, 
  onDismiss,
  variant = 'default' 
}) => (
  <div className={`ux-error-state ${variant}`}>
    <div className="ux-error-icon">⚠</div>
    <div className="ux-error-content">
      <p className="ux-error-message">{message}</p>
      <div className="ux-error-actions">
        {onRetry && (
          <button className="ux-error-retry" onClick={onRetry}>
            Retry
          </button>
        )}
        {onDismiss && (
          <button className="ux-error-dismiss" onClick={onDismiss}>
            Dismiss
          </button>
        )}
      </div>
    </div>
  </div>
);

const UXStates = {
  LoadingSpinner,
  EmptyState,
  SuccessState,
  ErrorState,
};

export default UXStates;